<script setup lang="ts">
import { computed } from 'vue'
import { clampPercent, formatPercent } from '@/utils/format'

const props = withDefaults(
  defineProps<{
    label: string
    value: number
    detail?: string
    warning?: number
    danger?: number
  }>(),
  { warning: 70, danger: 90, detail: '' },
)

const safeValue = computed(() => clampPercent(props.value))
const tone = computed(() => {
  if (safeValue.value >= props.danger) return 'bg-coral-500'
  if (safeValue.value >= props.warning) return 'bg-amber-400'
  return 'bg-moss-500'
})
</script>

<template>
  <div>
    <div class="mb-1.5 flex items-center justify-between gap-3 text-xs">
      <span class="font-medium text-slate-600">{{ label }}</span>
      <span class="font-mono text-[0.7rem] text-slate-500">
        {{ detail || formatPercent(safeValue) }}
      </span>
    </div>
    <div
      class="h-1.5 overflow-hidden rounded-full bg-slate-100"
      role="progressbar"
      :aria-label="label"
      :aria-valuenow="safeValue"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div
        class="h-full rounded-full transition-[width,background-color] duration-500"
        :class="tone"
        :style="{ width: `${safeValue}%` }"
      ></div>
    </div>
  </div>
</template>
